import { InjectionToken } from '@angular/core';
import { OLRVersion } from '../models/olr-version/olr-version.enum';

export const OLR_VERSION = new InjectionToken<OLRVersion>('OLR version token');
